export const DEFAULT_FY_START_MONTH = 4;
export const DEFAULT_ITEM_RATING_SCALE_MAX = 10;
export const DEFAULT_TOOL_THANK_YOU_MESSAGE = "Thank you. Your response has been submitted and will be in touch with you shortly.";
export const DEFAULT_FY_START_DAY = 6;
export const FY_ANCHOR_YEAR = 1970;
export const FY_START_MS_KEY = "fyStartMs";
export const FY_SPLIT_ENABLED_KEY = "isFySplitEnabled";
export const BOOK_EXPORT_DEFAULT_PAGE_SIZE_KEY = "bookExportDefaultPageSize";
export const BOOK_EXPORT_DEFAULT_ORIENTATION_KEY = "bookExportDefaultOrientation";

export const FREE_PLAN_IDS = [
	"free",
	"850092",
	"genogramStudentPlanId",
	"theralogik_free",
	"971132", //theralogik free plan
];

export const isFreePlanId = (planId) => {
	return FREE_PLAN_IDS.includes(planId);
};
